<template>
  <Layout :hideMobileMenu="true">
    <HeaderRoot title="Export" />
    <div class="return-box export__return-box export__return-box--mobile">
      <router-link :to="{ name: 'all_highlights' }" class="return-box__link">
        <span
          class="export__return-icon return-box__icon iconfont iprev"
        ></span>
        Back to Highlights
      </router-link>
    </div>

    <section class="export">
      <div class="container export__container">
        <div class="return-box export__return-box export__return-box--desktop">
          <router-link
            :to="{ name: 'all_highlights' }"
            class="return-box__link"
          >
            <span
              class="export__return-icon return-box__icon iconfont iprev"
            ></span>
            Back to Highlights
          </router-link>
        </div>
        <ExportSettings />
      </div>
    </section>
  </Layout>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import Layout from '@/app/components/Layout.vue'
import HeaderRoot from '@/app/components/header/Root.vue'
import ExportSettings from '@/app/components/export/ExportSettings.vue'
import { HeaderView } from '@/models/header'

const view = ref<HeaderView | null>(null)

onBeforeMount(async () => {
  view.value = new HeaderView()
  await view.value.init()
})
</script>
